import React from 'react';
import { motion } from 'framer-motion';
export function SectionHeader({
  number,
  title
}: {
  number: string;
  title: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} className="flex items-baseline gap-4 mb-12 md:mb-20 border-b border-brand-white/10 pb-4" data-id="element-91">
      
      <h2 className="text-4xl md:text-6xl font-display tracking-widest uppercase text-brand-white" data-id="element-92">
        {title}
      </h2>
    </motion.div>;
}